<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Agrani Bank,Main Branch-New User</div>
        <div>
          <bread-crumb
            :bread-crumbs="[
              'Partner Summary',
              'Partner Branch',
              'User Detail',
              'Main Branch',
            ]"
          />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <!-- <v-row class="mt-2 ms-1 me-1">
        <v-col cols="12" md="6">
          <h3 class="labelFontsize  mb-0 mt-2 mb-4">Agrani Bank, Main Branch -Test01</h3>
        </v-col>
      </v-row> -->

      <v-row class="mt-2 ms-1 me-1">
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Login ID</label>
          <v-text-field outlined dense class="rounded" placeholder="Login ID">
          </v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0 required">Name</label>
          <v-text-field outlined dense class="rounded" placeholder="Name">
          </v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Post</label>
          <v-text-field outlined dense class="rounded" placeholder="Post">
          </v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Address</label>
          <v-text-field outlined dense class="rounded" placeholder="Address">
          </v-text-field>
        </v-col>
      </v-row>
      <v-row class="mt-2 ms-1 me-1">
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0 required">Email</label>
          <v-text-field outlined dense class="rounded" placeholder="Email">
          </v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Mobile Number</label>
          <v-text-field
            outlined
            dense
            class="rounded"
            placeholder="Mobile Number"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Branch Name</label>
          <v-text-field
            outlined
            dense
            class="rounded"
            placeholder="Branch Name"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">View Pass Trans.Limit</label>
          <v-text-field
            outlined
            dense
            class="rounded"
            placeholder="View Pass Trans Limit"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row class="mt-2 ms-1 me-1">
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0"
            >Must Required 2 Factor Authentification</label
          >
          <v-autocomplete
            outlined
            dense
            class="rounded"
            placeholder="Must Required Two Factor Authentification"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Deactive User</label>
          <v-text-field
            outlined
            dense
            class="rounded"
            placeholder="Deactive User"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Remarks</label>
          <v-textarea outlined dense class="rounded" placeholder="Remarks">
          </v-textarea>
        </v-col>
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Change Password</label>
          <v-autocomplete
            outlined
            dense
            class="rounded"
            placeholder="Change Password"
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="ms-5 me-1">
        <v-col cols="12" md="2">
          <v-switch label="Allow Integration"></v-switch>
        </v-col>
      </v-row>

      <v-row class="ms-1 me-1">
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Roles</label>
        </v-col>
      </v-row>
      <v-row class="ms-5 me-1">
        <v-col cols="12" md="2">
          <v-switch label="Branch Manager"></v-switch>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch label="Traior"></v-switch>
        </v-col>
      </v-row>

      <v-row justify="end">
        <!-- <v-spacer></v-spacer> -->

        <v-btn depressed  small color="primary" class="mx-2 mt-2 me-5 text-capitalize"
          >Update</v-btn
        >
        <v-btn depressed 
          small
          color="primary"
          class="mx-2 mt-2 me-5 text-capitalize"
          outlined
        >
          Audit
        </v-btn>
        <v-btn depressed 
          small
          color="primary"
          class="mx-2 mt-2 me-5 text-capitalize"
          outlined
        >
          Email Password setup link
        </v-btn>
        <v-btn depressed 
          small
          color="primary"
          class="mx-2 me-5 mb-2 mt-2 text-capitalize"
          outlined
        >
          Disable user
        </v-btn>
      </v-row>

      <v-row class="mt-2 ms-1 me-1 mb-5">
        <v-col cols="12" md="10">
          <v-col cols="12" md="3">
            <div class="d-flex justify-space-between">
              <div>
                <label class="labelFontsize mb-0">User Created By</label>
              </div>
              <div><label></label></div>
            </div>
          </v-col>
        </v-col>
      </v-row>
      <v-row class="mt-2 ms-1 me-1 mb-5">
        <v-col cols="12" md="10">
          <v-col cols="12" md="3">
            <div class="d-flex justify-space-between">
              <div>
                <label class="labelFontsize mb-0">User Approved By</label>
              </div>
              <div><label></label></div>
            </div>
          </v-col>
        </v-col>
      </v-row>
      <v-row class="mt-2 ms-1 me-1 mb-5">
        <v-col cols="12" md="10">
          <v-col cols="12" md="3">
            <div class="d-flex justify-space-between">
              <div>
                <label class="labelFontsize mb-0">User Last Login Form:</label>
              </div>
              <div><label></label></div>
            </div>
          </v-col>
        </v-col>
      </v-row>
      <v-row class="mt-2 ms-1 me-1 mb-5">
        <v-col cols="12" md="10">
          <v-col cols="12" md="3">
            <div class="d-flex justify-space-between">
              <div><label class="labelFontsize mb-0">Status:</label></div>
              <div><label></label></div>
            </div>
          </v-col>
        </v-col>
      </v-row>
      <v-row class="ms-1 me-1">
        <v-col cols="12" md="3">
          <label class="labelFontsize mb-0">Audit Log:</label>
        </v-col>
      </v-row>

      <v-data-table fixed-header  height="55vh" :headers="headers" :items="desserts" dense class="mt-6">
        <template v-slot:item.actions="{ item }">
          <v-icon small color="primary" class="mr-2" @click="editItem(item)">
            mdi-trash-can-outline
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";

export default {
  name: "Main Branch",

  data: () => {
    return {
      headers: [
        { text: "Log Date", value: "Log_Date" },
        { text: "User ID", value: "User_ID" },
        { text: "Remarks", value: "Remarks" },
      ],
      desserts: [
        {
          Log_Date: "No Audit Log",
          User_ID: "",
          Remarks: "",
        },
      ],
    };
  },

  components: {
    BreadCrumb,
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
